// extracted by mini-css-extract-plugin
export default {"wrapper":"Sy-z","viewport":"Ty-z","container":"Uy-z","slide":"Vy-z"};